import { useInfrastructureWizard } from '@/stores/infrastructureWizard'
import styles from './Infrastructure.module.css'
import { DbServerSection } from './DbServerSection'
import { RdsServerSection } from './RdsServerSection'
import { SqlInstanceQuestion } from './SqlInstanceQuestion'

/**
 * Two independent questions, on both levels: is the RDS server Existing or Dedicated, and is the DB server? Then the one SQL instance
 * question. Each server keeps its own values, so changing one choice never touches the other.
 */
export function ServersStep({ requiredIps }: { requiredIps?: number }) {
  const level = useInfrastructureWizard((s) => s.level)
  if (!level) return <p className={styles.note}>Choose the level first.</p>
  return (
    <>
      <RdsServerSection />
      <DbServerSection requiredIps={requiredIps} />
      <SqlInstanceQuestion />
    </>
  )
}
